import { action, atom } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { Array } from '@blade/std-lib'
import { STORAGE_PREFIX } from '@root/shared'

import { ExploreLayout } from '../model'
import { ExploreFeedType } from '../model/explore-feed-type'

const initLayout: ExploreLayout.Columns = [
  ExploreFeedType.Trending,
  ExploreFeedType.New,
  ExploreFeedType.TopGainers,
]

const exploreAllColumnsAtom = atom<ExploreLayout.Columns>(
  initLayout,
  'exploreAllColumnsAtom',
).pipe(withLocalStorage(`${STORAGE_PREFIX}/v1/explore-columns-feed`))

export const exploreLayoutTypeAtom = atom<ExploreLayout.Type>(
  ExploreLayout.Type.ThreeColumns,
  'exploreLayoutTypeAtom',
).pipe(withLocalStorage(`${STORAGE_PREFIX}/v1/explore-layout-type`))

export const exploreColumnsAtom = atom((ctx) => {
  const type = ctx.spy(exploreLayoutTypeAtom)
  const columns = ctx.spy(exploreAllColumnsAtom)
  return Array.take(ExploreLayout.columnsCount(type))(columns)
}, 'exploreColumnsAtom')

export const setLayoutColumnAction = action(
  (ctx, column: ExploreLayout.Column, feed: ExploreFeedType) => {
    exploreAllColumnsAtom(
      ctx,
      ExploreLayout.changeColumnFeed(
        ctx.get(exploreAllColumnsAtom),
        column,
        feed,
      ),
    )
  },
  'setLayoutColumnAction',
)

export const setLayoutTypeAction = action((ctx, type: ExploreLayout.Type) => {
  exploreLayoutTypeAtom(ctx, type)
}, 'setLayoutTypeAction')
